import React from 'react';
import PropTypes from 'prop-types';
import {PageContainer} from '@/components/organisms';
import LeaderboardSection from '../shared/Leaderboard/LeaderboardSection';

const FreeKickAttributes = ({formData, handleFormChange}) => {
  return (
    <PageContainer data-testid='freekick-attributes-form'>
      <LeaderboardSection
        formData={formData}
        handleFormChange={handleFormChange}
      />
    </PageContainer>
  );
};

FreeKickAttributes.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired
};

export default React.memo(FreeKickAttributes);
